import React from 'react'

export default function TableRayons({ listeRayons, t }) {
    return (
        <div className='card'>

            <div className='card-header'>
                <h6 className='card-title mt-3 text-center '> {t('rapports.rayonproduit')} </h6>
            </div>
            <div className='card-body'>
                <div className="panel panel-body mb-2" style={{ overflow: 'scroll', height: "300px" }}>
                    {/** Tableau rupture Produits  */}
                    <div className="table-responsive  product-datatable">
                        <table className="table  table-bordered ">
                            <thead className="text-center bg-azure-lighter">
                                <tr>
                                    <th className="wd-15p fs-12">{t('rapports.rayonproduit')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.prix')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.facing')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.tg')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.tr')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.sp')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.rayon')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.ac')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.sol')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.main')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.remise')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.gratuite')}</th>
                                    <th className="wd-15p fs-12">{t('rapports.cartefid')}</th>
                                </tr>
                            </thead>
                            <tbody className='text-center fs-12'>
                                {listeRayons.length === 0 ?
                                    <tr>
                                        <td colSpan={13} className='text-center text-danger'> {t('rapports.aucuneinfo')}
                                            <hr className='hr1' />
                                            <img src="../assets/images/photos/no.png" alt='noData' style={{ height: "200px" }} />
                                        </td>                                    </tr> :
                                    listeRayons?.map((items, keys) => (
                                        <tr key={keys} className={
                                            keys % 2 === 1 ? "fs-12 bg-azure-lightest" : "fs-12"
                                        } >
                                            <td>{items.produit}</td>
                                            <td>{parseFloat(items.prix).toFixed(3)}</td>
                                            <td>{items.facing}</td>
                                            <td>{items.tg}</td>
                                            <td>{items.tr}</td>
                                            <td>{items.sp}</td>
                                            <td>{items.rayon}</td>
                                            <td>{items.ac}</td>
                                            <td>{items.sol}</td>
                                            <td>{items.main}</td>
                                            <td>{items.remise}</td>
                                            <td>{items.gratuite}</td>
                                            <td>{items.cartefid}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}
